import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../../../context/LanguageContext';
import '../../../../assets/css/style.css';
import '../style/footer.css';
import footerLogo from '../../../../assets/logo/logo/main.webp';
import dpdLogo from '../../../../assets/logo/footer/DPD_logo_white.webp';
import livroReclamacoesLogo from '../../../../assets/logo/footer/livro_reclamacoes1.webp';
import myouwebLogo from '../../../../assets/logo/footer/myouweb.webp';
import { trackEmailClick, trackPhoneClick } from '../../email/utils/trackingUtils';

const Footer: React.FC = () => {
    const { t } = useLanguage();
    const currentYear = new Date().getFullYear();

    return (
        <footer className="site-footer-new">
            {/* Footer Top Section */}
            <div className="footer-new__top">
                <div className="container">
                    <div className="footer-new__content">
                        <div className="row">
                            {/* About Section */}
                            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                <div className="footer-new__about">
                                    {/* Left side: Logo and Social (for mobile) */}
                                    <div className="footer-new__about-left">
                                        <div className="footer-new__logo">
                                            <Link to="/">
                                                <img loading="lazy" src={footerLogo} alt="Roady Chaves" className="footer-logo-img" />
                                            </Link>
                                        </div>
                                        <p className="footer-new__about-text">
                                            {t.FOOTER.footerAboutText}
                                        </p>
                                        <div className="footer-new__social">
                                            <a href="https://www.facebook.com/roadychaves" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Facebook">
                                                <i className="fab fa-facebook-f"></i>
                                            </a>
                                            <a href="https://www.instagram.com/roadychaves/" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
                                                <i className="fab fa-instagram"></i>
                                            </a>
                                        </div>
                                    </div>
                                    
                                    {/* Right side: DPD and Livro de Reclamações (Desktop Only) */}
                                    <div className="footer-new__about-right footer-new__about-right--desktop">
                                        {/* DPD Logo */}
                                        <div className="footer-new__dpd-logo">
                                            <a href="https://www.dpd.com/pt/pt/" target="_blank" rel="noopener noreferrer" className="dpd-logo-link" aria-label="DPD">
                                                <img loading="lazy" src={dpdLogo} alt="DPD" className="dpd-logo-img" />
                                            </a>
                                        </div>
                                        
                                        {/* Livro de Reclamações Button */}
                                        <div className="footer-new__complaints-book">
                                            <a href="https://www.livroreclamacoes.pt/Inicio/" target="_blank" rel="noopener noreferrer" className="complaints-book-link" aria-label="Livro de Reclamações">
                                                <img loading="lazy" src={livroReclamacoesLogo} alt="Livro de Reclamações" className="complaints-book-img" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Quick Links Section */}
                            <div className="col-xl-2 col-lg-2 col-md-6 col-sm-12">
                                <div className="footer-new__links">
                                    <h4 className="footer-new__title">{t.FOOTER.footerQuickLinks}</h4>
                                    <ul className="footer-new__link-list">
                                        <li>
                                            <Link to="/oficina" className="footer-link">
                                                <i className="fas fa-angle-right"></i>
                                                <span>{t.NAVIGATION.workshop}</span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/loja" className="footer-link">
                                                <i className="fas fa-angle-right"></i>
                                                <span>{t.NAVIGATION.store}</span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/loja/pneus" className="footer-link">
                                                <i className="fas fa-angle-right"></i>
                                                <span>{t.NAVIGATION.tires}</span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/orcamento" className="footer-link">
                                                <i className="fas fa-angle-right"></i>
                                                <span>{t.NAVIGATION.budget}</span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/contacto" className="footer-link">
                                                <i className="fas fa-angle-right"></i>
                                                <span>{t.FOOTER.contact}</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            {/* Services Section */}
                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                <div className="footer-new__services">
                                    <h4 className="footer-new__title">{t.FOOTER.footerOurServices}</h4>
                                    <div className="footer-new__services-grid">
                                        <ul className="footer-new__link-list">
                                            <li>
                                                <Link to="/oficina/alinhamento" className="footer-link">
                                                    <i className="fas fa-angle-right"></i>
                                                    <span>{t.SERVICES.alignment}</span>
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/oficina/teste-diagnostico" className="footer-link">
                                                    <i className="fas fa-angle-right"></i>
                                                    <span>{t.SERVICES.diagnosticTest}</span>
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/oficina/baterias" className="footer-link">
                                                    <i className="fas fa-angle-right"></i>
                                                    <span>{t.SERVICES.batteries}</span>
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/oficina/travoes" className="footer-link">
                                                    <i className="fas fa-angle-right"></i>
                                                    <span>{t.SERVICES.brakes}</span>
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/oficina/lavagem" className="footer-link">
                                                    <i className="fas fa-angle-right"></i>
                                                    <span>{t.SERVICES.washing}</span>
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/oficina/restauro-farois" className="footer-link">
                                                    <i className="fas fa-angle-right"></i>
                                                    <span>{t.SERVICES.headlightRestoration}</span>
                                                </Link>
                                            </li>
                                        </ul>
                                        <ul className="footer-new__link-list">
                                            <li>
                                                <Link to="/oficina/revisoes-roady" className="footer-link">
                                                    <i className="fas fa-angle-right"></i>
                                                    <span>{t.SERVICES.roadyReview}</span>
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/oficina/amortecedores" className="footer-link">
                                                    <i className="fas fa-angle-right"></i>
                                                    <span>{t.SERVICES.shockAbsorbers}</span>
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/oficina/inspecao" className="footer-link">
                                                    <i className="fas fa-angle-right"></i>
                                                    <span>{t.SERVICES.inspection}</span>
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/oficina/mecanica-geral" className="footer-link">
                                                    <i className="fas fa-angle-right"></i>
                                                    <span>{t.SERVICES.generalMechanics}</span>
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/oficina/servicos-oficina" className="footer-link">
                                                    <i className="fas fa-angle-right"></i>
                                                    <span>{t.SERVICES.workshopServices}</span>
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/oficina/ar-condicionado" className="footer-link">
                                                    <i className="fas fa-angle-right"></i>
                                                    <span>{t.SERVICES.airConditioning}</span>
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* Contact Section */}
                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                <div className="footer-new__contact">
                                    <h4 className="footer-new__title">{t.FOOTER.footerContactInfo}</h4>
                                    <ul className="footer-new__contact-list">
                                        <li className="contact-item">
                                            <div className="contact-icon">
                                                <i className="icon-location"></i>
                                            </div>
                                            <div className="contact-content">
                                                <span className="contact-label">{t.FOOTER.footerLocation}</span>
                                                <p>
                                                    <a 
                                                        href="https://maps.app.goo.gl/DgxqS5RGtrD7Vks5A"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        R. Joaquim Mazarém 28, 5400-695 Chaves
                                                    </a>
                                                </p>
                                            </div>
                                        </li>
                                        <li className="contact-item">
                                            <div className="contact-icon">
                                                <i className="icon-phone-call"></i>
                                            </div>
                                            <div className="contact-content">
                                                <span className="contact-label">{t.FOOTER.footerPhone}</span>
                                                <p>
                                                    <a href={`tel:${String(t.CONTACT.number).replace(/[()\s-]/g, '')}`} onClick={() => trackPhoneClick('footer')}>{t.CONTACT.number}</a>
                                                    <span className="phone-info-text">{t.CONTACT.phoneCallInfo}</span>
                                                </p>
                                            </div>
                                        </li>
                                        <li className="contact-item">
                                            <div className="contact-icon">
                                                <i className="icon-email"></i>
                                            </div>
                                            <div className="contact-content">
                                                <span className="contact-label">{t.FOOTER.footerEmail}</span>
                                                <p><a href="mailto:geral@roadychaves.com" onClick={() => trackEmailClick('footer')}>geral@roadychaves.com</a></p>
                                            </div>
                                        </li>
                                    </ul>
                                    
                                    {/* DPD and Livro de Reclamações - Mobile Only (shown under contact) */}
                                    <div className="footer-new__about-right footer-new__about-right--mobile">
                                        {/* DPD Logo */}
                                        <div className="footer-new__dpd-logo">
                                            <a href="https://www.dpd.com/pt/pt/" target="_blank" rel="noopener noreferrer" className="dpd-logo-link" aria-label="DPD">
                                                <img loading="lazy" src={dpdLogo} alt="DPD" className="dpd-logo-img" />
                                            </a>
                                        </div>
                                        
                                        {/* Livro de Reclamações Button */}
                                        <div className="footer-new__complaints-book">
                                            <a href="https://www.livroreclamacoes.pt/Inicio/" target="_blank" rel="noopener noreferrer" className="complaints-book-link" aria-label="Livro de Reclamações">
                                                <img loading="lazy" src={livroReclamacoesLogo} alt="Livro de Reclamações" className="complaints-book-img" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {/* Footer Bottom Section */}
            <div className="footer-new__bottom">
                <div className="container">
                    <div className="footer-new__ai-notice">
                        <p>
                            {t.FOOTER.footerAiNotice}{' '}
                            <Link to="/termos-condicoes">{t.FOOTER.footerAiNoticeLink}</Link>.
                        </p>
                    </div>
                    <div className="footer-new__bottom-content">
                        <div className="footer-new__copyright">
                            <p className="copyright-text">
                                <span>{t.FOOTER.footerDevelopedBy}</span>
                                <a href="https://myouweb.com" target="_blank" rel="noopener noreferrer" className="myouweb-link">
                                    <img loading="lazy" src={myouwebLogo} alt="Myouweb" className="myouweb-logo" />
                                </a>
                                <span className="separator">|</span>
                                <span className="copyright-year">{currentYear}</span>
                            </p>
                        </div>
                        <div className="footer-new__legal">
                            <ul className="legal-links">
                                <li><Link to="/politica-cookies">{t.FOOTER.footerCookies}</Link></li>
                                <li>
                                    <a
                                        href="#cookie-settings"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            window.dispatchEvent(new Event('openCookieSettings'));
                                        }}
                                    >
                                        {t.FOOTER.footerCookieSettings}
                                    </a>
                                </li>
                                <li><Link to="/termos-condicoes">{t.FOOTER.footerTerms}</Link></li>
                                <li><Link to="/politica-privacidade">{t.FOOTER.footerPrivacy}</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;

